// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__22S2V","col":"styles_col__1XzD2"};